import * as React from "react";
import { RioUnsafe, IRioResource } from "rio.react.all";

interface IPageHeadingProps {
    resource: IRioResource;
}

export class PageHeading extends React.Component<IPageHeadingProps, null> {
    render() {
        return (
            <section className="heading">
                {!!this.props.resource.image && <RioUnsafe html={this.props.resource.image} className="icon" />}
                <span>{this.props.resource.text}</span>
            </section>
        );
    }
}